import React, { useState, memo } from 'react';
import { PartyPopper, Package, Users, Calendar, ChevronDown, ChevronUp, Check, Clock } from 'lucide-react';
import Button from '../../components/ui/Button';
const PartyPlanner: React.FC = () => {
  const [activePackage, setActivePackage] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    eventType: 'team',
    people: 10,
    date: '',
    budget: 20,
    requests: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const togglePackage = (id: string) => {
    setActivePackage(activePackage === id ? null : id);
  };
  return <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1159">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#E84118] to-[#c83616] rounded-lg p-6 md:p-8 text-white mb-6 md:mb-8" data-id="element-1160">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-1161">
          <div className="mb-4 md:mb-0" data-id="element-1162">
            <h1 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-1163">
              Party Planner
            </h1>
            <p className="text-base md:text-lg opacity-90" data-id="element-1164">
              Make your office celebrations memorable with our curated party
              packages
            </p>
          </div>
          <div className="flex items-center bg-white bg-opacity-20 rounded-lg p-3" data-id="element-1165">
            <PartyPopper className="text-white mr-2" size={20} data-id="element-1166" />
            <span className="text-sm md:text-base" data-id="element-1167">
              Next-day delivery available!
            </span>
          </div>
        </div>
      </div>
      {/* Party Packages */}
      <h2 className="text-xl font-bold mb-4" data-id="element-1168">Popular Party Packages</h2>
      <div className="space-y-4 mb-8" data-id="element-1169">
        {/* Pizza Party Package */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-1170">
          <div className="p-5 cursor-pointer flex justify-between items-center" onClick={() => togglePackage('pizza')} data-id="element-1171">
            <div className="flex items-center" data-id="element-1172">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4" data-id="element-1173">
                <PartyPopper size={20} className="text-red-500" data-id="element-1174" />
              </div>
              <div data-id="element-1175">
                <h3 className="text-lg font-bold" data-id="element-1176">Pizza Party Package</h3>
                <p className="text-sm text-gray-500" data-id="element-1177">
                  Perfect for team celebrations
                </p>
              </div>
            </div>
            <div className="flex items-center" data-id="element-1178">
              <span className="font-bold text-lg mr-4" data-id="element-1179">$199</span>
              {activePackage === 'pizza' ? <ChevronUp size={20} className="text-gray-500" data-id="element-1180" /> : <ChevronDown size={20} className="text-gray-500" data-id="element-1181" />}
            </div>
          </div>
          {activePackage === 'pizza' && <div className="p-5 pt-0 border-t border-gray-100 bg-gray-50" data-id="element-1182">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-1183">
                <div className="space-y-2" data-id="element-1184">
                  <div className="flex items-center" data-id="element-1185">
                    <Users size={18} className="text-gray-500 mr-2" data-id="element-1186" />
                    <span className="text-gray-700" data-id="element-1187">For 10-15 people</span>
                  </div>
                  <div className="flex items-center" data-id="element-1188">
                    <Package size={18} className="text-gray-500 mr-2" data-id="element-1189" />
                    <span className="text-gray-700" data-id="element-1190">
                      5 Large Pizzas + Sides
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-1191">
                    <PartyPopper size={18} className="text-gray-500 mr-2" data-id="element-1192" />
                    <span className="text-gray-700" data-id="element-1193">
                      Includes Trivia Game Kit
                    </span>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-1194">
                  <div className="flex items-center" data-id="element-1195">
                    <Check size={18} className="text-green-500 mr-2" data-id="element-1196" />
                    <span className="text-gray-700" data-id="element-1197">Drinks included</span>
                  </div>
                  <div className="flex items-center" data-id="element-1198">
                    <Check size={18} className="text-green-500 mr-2" data-id="element-1199" />
                    <span className="text-gray-700" data-id="element-1200">
                      Plates, cups & napkins
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-1201">
                    <Clock size={18} className="text-gray-500 mr-2" data-id="element-1202" />
                    <span className="text-gray-700" data-id="element-1203">
                      24h advance booking required
                    </span>
                  </div>
                </div>
              </div>
              <Button fullWidth data-id="element-1204">Book Pizza Party - $199</Button>
            </div>}
        </div>
        {/* Sushi Party Package */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-1205">
          <div className="p-5 cursor-pointer flex justify-between items-center" onClick={() => togglePackage('sushi')} data-id="element-1206">
            <div className="flex items-center" data-id="element-1207">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-1208">
                <PartyPopper size={20} className="text-blue-500" data-id="element-1209" />
              </div>
              <div data-id="element-1210">
                <h3 className="text-lg font-bold" data-id="element-1211">Sushi Party Package</h3>
                <p className="text-sm text-gray-500" data-id="element-1212">
                  Premium option for special occasions
                </p>
              </div>
            </div>
            <div className="flex items-center" data-id="element-1213">
              <span className="font-bold text-lg mr-4" data-id="element-1214">$249</span>
              {activePackage === 'sushi' ? <ChevronUp size={20} className="text-gray-500" data-id="element-1215" /> : <ChevronDown size={20} className="text-gray-500" data-id="element-1216" />}
            </div>
          </div>
          {activePackage === 'sushi' && <div className="p-5 pt-0 border-t border-gray-100 bg-gray-50" data-id="element-1217">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-1218">
                <div className="space-y-2" data-id="element-1219">
                  <div className="flex items-center" data-id="element-1220">
                    <Users size={18} className="text-gray-500 mr-2" data-id="element-1221" />
                    <span className="text-gray-700" data-id="element-1222">For 8-12 people</span>
                  </div>
                  <div className="flex items-center" data-id="element-1223">
                    <Package size={18} className="text-gray-500 mr-2" data-id="element-1224" />
                    <span className="text-gray-700" data-id="element-1225">Premium Sushi Platter</span>
                  </div>
                  <div className="flex items-center" data-id="element-1226">
                    <PartyPopper size={18} className="text-gray-500 mr-2" data-id="element-1227" />
                    <span className="text-gray-700" data-id="element-1228">
                      Includes Bingo Game Set
                    </span>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-1229">
                  <div className="flex items-center" data-id="element-1230">
                    <Check size={18} className="text-green-500 mr-2" data-id="element-1231" />
                    <span className="text-gray-700" data-id="element-1232">
                      Premium drinks & desserts
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-1233">
                    <Check size={18} className="text-green-500 mr-2" data-id="element-1234" />
                    <span className="text-gray-700" data-id="element-1235">
                      Eco-friendly tableware
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-1236">
                    <Clock size={18} className="text-gray-500 mr-2" data-id="element-1237" />
                    <span className="text-gray-700" data-id="element-1238">
                      48h advance booking required
                    </span>
                  </div>
                </div>
              </div>
              <Button fullWidth data-id="element-1239">Book Sushi Party - $249</Button>
            </div>}
        </div>
      </div>
      {/* Custom Party Form */}
      <div className="bg-white rounded-lg shadow-md p-5 md:p-6" data-id="element-1240">
        <div className="flex items-center mb-4" data-id="element-1241">
          <Calendar className="text-[#E84118] mr-2" size={22} data-id="element-1242" />
          <h2 className="text-xl font-bold" data-id="element-1243">Plan Custom Party</h2>
        </div>
        <form data-id="element-1244">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-1245">
            <div data-id="element-1246">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1247">
                Event Type
              </label>
              <select name="eventType" value={formData.eventType} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-1248">
                <option value="team" data-id="element-1249">Team Celebration</option>
                <option value="birthday" data-id="element-1250">Birthday Party</option>
                <option value="meeting" data-id="element-1251">Office Meeting</option>
                <option value="holiday" data-id="element-1252">Holiday Party</option>
              </select>
            </div>
            <div data-id="element-1253">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1254">
                Number of People
              </label>
              <input type="number" name="people" value={formData.people} onChange={handleChange} min="5" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-1255" />
            </div>
            <div data-id="element-1256">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1257">
                Preferred Date
              </label>
              <input type="date" name="date" value={formData.date} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-1258" />
            </div>
            <div data-id="element-1259">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1260">
                Budget per Person ($)
              </label>
              <input type="number" name="budget" value={formData.budget} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-1261" />
            </div>
          </div>
          <div className="mt-5" data-id="element-1262">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1263">
              Special Requests
            </label>
            <textarea name="requests" value={formData.requests} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" rows={3} placeholder="Dietary requirements, themes, or other special requests..." data-id="element-1264"></textarea>
          </div>
          <div className="mt-6" data-id="element-1265">
            <Button type="submit" fullWidth data-id="element-1266">
              Get Quote
            </Button>
            <p className="mt-2 text-xs text-center text-gray-500" data-id="element-1267">
              We'll respond with a custom quote within 24 hours
            </p>
          </div>
        </form>
      </div>
    </div>;
};
export default PartyPlanner;